import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiUsers, FiTarget, FiEye, FiArrowRight } = FiIcons;

const AboutMobile = () => {
  return (
    <div className="space-y-6 pb-16">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-white rounded-xl shadow-lg p-6 border border-gray-100 text-center"
      >
        <div className="w-12 h-12 bg-gradient-to-br from-primary-500 to-primary-600 rounded-xl mx-auto mb-4 flex items-center justify-center shadow-md">
          <span className="text-white font-bold text-lg drop-shadow-sm">ILM</span>
        </div>
        <h1 className="text-2xl font-bold text-gray-800 mb-2">About ILM Global</h1>
        <p className="text-gray-600 text-sm">
          Inspirational Leadership Movement (ILM) Global is dedicated to empowering young people through education, mentorship, and leadership development in Sierra Leone and The Gambia.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 gap-4">
        <Link to="/mission">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="bg-white rounded-xl shadow-lg p-6 border border-gray-100"
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-4">
                <div className="bg-primary-100 p-3 rounded-full">
                  <SafeIcon icon={FiTarget} className="w-6 h-6 text-primary-600" />
                </div>
                <div>
                  <h2 className="font-bold text-gray-800">Our Mission</h2>
                  <p className="text-gray-600 text-sm">What we do and why we do it</p>
                </div>
              </div>
              <SafeIcon icon={FiArrowRight} className="w-5 h-5 text-gray-400" />
            </div>
          </motion.div>
        </Link>

        <Link to="/vision">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="bg-white rounded-xl shadow-lg p-6 border border-gray-100"
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-4">
                <div className="bg-primary-100 p-3 rounded-full">
                  <SafeIcon icon={FiEye} className="w-6 h-6 text-primary-600" />
                </div>
                <div>
                  <h2 className="font-bold text-gray-800">Our Vision</h2>
                  <p className="text-gray-600 text-sm">The future we're working towards</p>
                </div>
              </div>
              <SafeIcon icon={FiArrowRight} className="w-5 h-5 text-gray-400" />
            </div>
          </motion.div>
        </Link>

        <Link to="/about">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
            className="bg-white rounded-xl shadow-lg p-6 border border-gray-100"
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-4">
                <div className="bg-primary-100 p-3 rounded-full">
                  <SafeIcon icon={FiUsers} className="w-6 h-6 text-primary-600" />
                </div>
                <div>
                  <h2 className="font-bold text-gray-800">About Us</h2>
                  <p className="text-gray-600 text-sm">Our story, team, and impact</p>
                </div>
              </div>
              <SafeIcon icon={FiArrowRight} className="w-5 h-5 text-gray-400" />
            </div>
          </motion.div>
        </Link>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4 }}
        className="bg-gradient-to-r from-primary-500 to-primary-600 rounded-xl shadow-lg p-6 text-white text-center"
      >
        <h2 className="text-xl font-bold mb-3">Join Our Movement</h2>
        <p className="text-white text-sm opacity-90 mb-4">
          Together, we can transform education and leadership development across West Africa.
        </p>
        <button className="bg-white text-primary-600 px-6 py-2 rounded-lg font-medium hover:bg-gray-50 transition-colors text-sm">
          Get Involved
        </button>
      </motion.div>

      <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-100">
        <h2 className="text-lg font-bold text-gray-800 mb-4">Quick Facts</h2>
        <div className="space-y-3">
          <div className="flex justify-between items-center pb-2 border-b border-gray-100">
            <span className="text-gray-600 text-sm">Founded</span>
            <span className="font-medium text-gray-800 text-sm">2015</span>
          </div>
          <div className="flex justify-between items-center pb-2 border-b border-gray-100">
            <span className="text-gray-600 text-sm">Students Impacted</span>
            <span className="font-medium text-gray-800 text-sm">5,000+</span>
          </div>
          <div className="flex justify-between items-center pb-2 border-b border-gray-100">
            <span className="text-gray-600 text-sm">Partner Schools</span>
            <span className="font-medium text-gray-800 text-sm">45+</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-gray-600 text-sm">Countries</span>
            <span className="font-medium text-gray-800 text-sm">Sierra Leone & The Gambia</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutMobile;